document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('form[form-request]');

    forms.forEach(function (form) {
        form.addEventListener('submit', function (event) {
            event.preventDefault();

            const submitButton = form.querySelector('button[type="submit"]');
            form.classList.add('pending');
            submitButton.disabled = true;

            const formData = new FormData(form);
            formData.append('action', 'request_form');
            formData.append('nonce', form.querySelector('[name="nonce"]').value);

            fetch(window.api_settings.ajax_url, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => response.json())
            .then(data => {
                form.classList.remove('pending');
                if (data.status === 'done') {
                    form.classList.add('success');
                    form.reset();
                } else {
                    form.classList.add('error');
                }
                setTimeout(() => {
                    form.classList.remove('success', 'error');
                    submitButton.disabled = false;
                }, 5000);
            })
            .catch(error => {
                console.error('Error:', error);
                form.classList.remove('pending');
                form.classList.add('error');
                setTimeout(() => {
                    form.classList.remove('error');
                    submitButton.disabled = false;
                }, 5000);
            });
        });
    });
});